import { Group, UnstyledButton } from '@mantine/core';
import { NotificationData, notifications } from '@mantine/notifications';
import classes from './toasts.module.css';
import { ToastIcon } from './ToastIcon';

const commonNotificationOptions: Partial<NotificationData> = {
  title: null,
  position: 'bottom-left',
  classNames: classes,
  withCloseButton: false,
};

export function showError(message: string) {
  notifications.show({
    ...commonNotificationOptions,
    message: message,
    icon: <ToastIcon variant="error" />,
    autoClose: 4000,
  });
}

export function showSuccess(message: string) {
  notifications.show({
    ...commonNotificationOptions,
    message: message,
    icon: <ToastIcon variant="success" />,
    autoClose: 2000,
  });
}

/** A success toast that also offers the next step, such as going to where the item went. */
export function showSuccessWithAction(
  message: string,
  action: { label: string; onClick: () => void },
) {
  const id = crypto.randomUUID();
  notifications.show({
    ...commonNotificationOptions,
    id,
    message: (
      <Group gap="lg" wrap="nowrap" justify="space-between">
        <span>{message}</span>
        <UnstyledButton
          className={classes.action}
          onClick={() => {
            notifications.hide(id);
            action.onClick();
          }}
        >
          {action.label}
        </UnstyledButton>
      </Group>
    ),
    icon: <ToastIcon variant="success" />,
    autoClose: 5000,
  });
}
